/** @jsx jsx */
import { css, jsx } from "@emotion/core"

export function CentralPlayerIcon({ show, icon }: { show: boolean; icon: "play" | "restart" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 263.374 263.374"
      version="1.1"
      viewBox="0 0 263.374 263.374"
      xmlSpace="preserve"
      css={css`
        all: unset;
        color: white;
        cursor: pointer;
        font: inherit;
        line-height: inherit;
        box-sizing: inherit;
        overflow: hidden;
        display: block;
        fill: currentColor;
        height: 50px;
        pointer-events: none;
        width: 50px;
        position: absolute;
        left: calc(50% - 25px);
        top: calc(50% - 25px);
        z-index: 5;
        filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
        opacity: ${show ? 0.8 : 0};
        transition: 0.2s;
      `}
    >
      {icon === "play" && (
        <path d="M238.163 115.57l-68.127-39.741a29241.192 29241.192 0 00-55.296-32.256L44.115 3.831C28.919-5.067 13.974 2.07 13.974 19.698v224c0 17.567 14.945 24.735 30.147 15.872l69.376-39.741c15.232-8.863 40.735-23.357 55.936-32.256l68.449-39.741c15.165-8.899 15.452-23.399.281-32.262z" />
      )}
      {icon === "restart" && (
        <path
          d="M232.7,117.3c-8,0-14.4,6.5-14.4,14.4c0,47.7-38.8,86.5-86.5,86.5s-86.5-38.8-86.5-86.5S84,45.1,131.7,45.1
	c21.2,0,41.4,7.8,57.1,21.6h-19.5c-8,0-14.4,6.5-14.4,14.4s6.5,14.4,14.4,14.4h50.2c8,0,14.4-6.5,14.4-14.4V31
	c0-8-6.5-14.4-14.4-14.4c-8,0-14.4,6.5-14.4,14.4v11.8c-20.5-17-46.3-26.5-73.4-26.5c-63.6,0-115.4,51.8-115.4,115.4
	s51.8,115.4,115.4,115.4s115.4-51.8,115.4-115.4C247.1,123.7,240.6,117.3,232.7,117.3z"
        />
      )}
    </svg>
  )
}
